export type ExternalUserType =
  | 'external_administrator'
  | 'external_individual';

export type ExternalRoleLabel = 'Administrator' | 'Individual';

export const isExternalAdministrator = (userType?: string | null): boolean =>
  userType === 'external_administrator';

export const roleLabelForUserType = (
  userType?: string | null,
): ExternalRoleLabel | null => {
  switch (userType) {
    case 'external_administrator':
      return 'Administrator';
    case 'external_individual':
      return 'Individual';
    default:
      return null;
  }
};

export const userTypeForRole = (role: ExternalRoleLabel): ExternalUserType =>
  role === 'Administrator'
    ? 'external_administrator'
    : 'external_individual';
